<script>
export default {
  mounted() {
    this.loginAuth0();
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.getters['auth/isAuthenticated']) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },

    loginAuth0 () {
      if (!this.checkLogin()) return

      this.$auth.loginWithRedirect({ onRedirectCallback: () => {
          this.$router.push(this.$route.query.to).catch(err => err)
        } })
    }
  }
}

</script>
